<script setup lang="ts">
import { computed, ref, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    modelValue: any
    error?: string
    label?: string
    description?: string
    name?: string
    options: Array<{ label: string; value: any }>
    property?: string
    size?: string
    v$?: any
    disabled?: boolean
    aligned?: 'vertical' | 'horizontal'
  }>(),
  {
    size: 'md',
    v$: {},
    disabled: false,
    aligned: 'horizontal',
  },
)

const error = computed(() => {
  const vuelidateErrors = props.v$[props.property || props.name]?.$errors || []
  const vuelidateInvalid = props.v$[props.property || props.name]?.$invalid?.value
    ? props.v$[props.property || props.name].$message
    : null
  return props.error || vuelidateErrors[0]?.$message || vuelidateInvalid
})
const selected_option = ref(props.modelValue)

watch(
  () => props.modelValue,
  (newVal) => {
    selected_option.value = newVal
  },
)

const emit = defineEmits(['update:modelValue'])

const label_base_class = 'font-medium text-gray-700 mb-2'
const label_sizes: any = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-md',
}

const label_classes = computed(() => {
  let comb_class = [label_base_class, label_sizes[props.size]]

  return comb_class
})

const onClickLabel = (option) => {
  if (props.disabled) return

  if (selected_option.value === option.value) {
    selected_option.value = null
    emit('update:modelValue', null)
  } else {
    selected_option.value = option.value
    emit('update:modelValue', option.value)
  }
}
</script>

<template>
  <div class="flex flex-col items-baseline gap-1" v-bind="$attrs">
    <div :class="label_classes" class="w-fit">{{ label }}</div>
    <p class="mb-2 text-sm text-gray-500" v-if="description">{{ description }}</p>
    <div class="flex gap-3" :class="{ 'flex-col': aligned === 'vertical' }">
      <div class="flex items-center gap-1" v-for="option in options" :key="option.value">
        <input
          v-model="selected_option"
          type="radio"
          :value="option.value"
          @click="() => onClickLabel(option)"
          :disabled="disabled"
        />
        <div class="text-sm" :class="{ 'cursor-pointer': !disabled }" @click="() => onClickLabel(option)">
          {{ option.label }}
        </div>
      </div>
    </div>
    <div v-if="error" class="mt-1 text-sm text-red-500">{{ error }}</div>
  </div>
</template>
